import { render } from "./EmployeeFiles.vue?vue&type=template&id=5094dc5d&scoped=true"
import script from "./EmployeeFiles.vue?vue&type=script&lang=js"
export * from "./EmployeeFiles.vue?vue&type=script&lang=js"

import "./EmployeeFiles.vue?vue&type=style&index=0&id=5094dc5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5094dc5d"]])

export default __exports__